// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Регіональні візити» (Regional visits, ключ `visit`, група `constituents`). */
export const regionalVisitsManifest: IModuleManifest = {
  key: 'visit',
  group: 'constituents',
  slug: 'regional-visits',
  prefix: 'VIS',
  name: { en: 'Regional visits', uk: 'Регіональні візити' },
  entities: [
    { key: 'visit', slug: 'visit', name: { en: 'Regional visits', uk: 'Регіональні візити' }, main: true },
    { key: 'visit_stop', slug: 'visit-stop', name: { en: 'Visit Stops', uk: 'Зупинки' }, main: false },
    { key: 'visit_participant', slug: 'visit-participant', name: { en: 'Visit Participants', uk: 'Учасники' }, main: false },
    { key: 'visit_commitment', slug: 'visit-commitment', name: { en: 'Visit Commitments', uk: 'Зобов’язання' }, main: false },
    { key: 'visit_expense', slug: 'visit-expense', name: { en: 'Visit Expenses', uk: 'Видатки' }, main: false },
    { key: 'visit_status', slug: 'visit-status', name: { en: 'Visit Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/regionalVisitsSlice').then((m) => m.regionalVisitsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
